import React, { useEffect } from 'react';
import { Trans } from '@lingui/macro';
import { FormData } from './Wizard';

type Props = {
    formData: FormData;
    handleChange?: any;
    isValid?: any;
}

const Step2 = ({ formData, handleChange, isValid }: Props) => {
    useEffect(() => {
        isValid(false);
        if (formData.questionTwo !== '') {
            isValid(true);
        }
    }, [formData, isValid]);

    const onChange = (value: string) => {
        if (handleChange) {
            const data = {
                ...formData,
                'questionTwo': value,
            }
            handleChange(data);
        }
    }

    return (
        <>
            <p className="my-1"><span className="fw-bold text-purple"><Trans id="h2">Question 2</Trans>:</span></p>
            <div className='mt-2'><strong><Trans id="q2">What type of license is it?</Trans></strong></div>
            <div className="pb-3">
                <div className="mb-3 form-check custom-radio">
                    <input
                        className="form-check-input custom-control-input float-start"
                        type="radio"
                        name="q2"
                        value="2.1"
                        id="2.1"
                        checked={formData.questionTwo === '2.1'}
                        onChange={(value) => onChange('2.1')}
                    />
                    <label className="form-check-label custom-control-label" htmlFor="2.1"><Trans id="q2.1">A single-user license (= installed on a specific computer, and only usable there)</Trans></label>
                </div>
                <div className="mb-3 form-check custom-radio">
                    <input
                        className="form-check-input custom-control-input float-start"
                        type="radio"
                        name="q2"
                        value="2.2"
                        id="2.2"
                        checked={formData.questionTwo === '2.2'}
                        onChange={(value) => onChange('2.2')}
                    />
                    <label className="form-check-label custom-control-label" htmlFor="2.2"><Trans id="q2.2">A floating network license (= installed on a license server, usable from multiple computers)</Trans></label>
                
                </div>
                <div className="mb-3 form-check custom-radio">
                    <input
                        className="form-check-input custom-control-input float-start"
                        type="radio"
                        name="q2"
                        value="2.3"
                        id="2.3"
                        checked={formData.questionTwo === '2.3'}
                        onChange={(value) => onChange('2.3')}
                    />
                    <label className="form-check-label custom-control-label" htmlFor="2.3"><Trans id="q2.3">A cloud license (= from a cloud container or PTV Hub, usable from multiple computers)</Trans></label>
                </div>
            </div>
        </>
    );
}

export default Step2;